__turbopack_context__.v({
  "desktopTopActions": "OnboardingWizardView-module__SaShFa__desktopTopActions",
  "elieContainer": "OnboardingWizardView-module__SaShFa__elieContainer",
  "elieImg": "OnboardingWizardView-module__SaShFa__elieImg",
  "floatingElieAvatarDesktop": "OnboardingWizardView-module__SaShFa__floatingElieAvatarDesktop",
  "floatingSupportMobile": "OnboardingWizardView-module__SaShFa__floatingSupportMobile",
  "floatingWhatsappDesktop": "OnboardingWizardView-module__SaShFa__floatingWhatsappDesktop",
  "leftColumn": "OnboardingWizardView-module__SaShFa__leftColumn",
  "logoContainer": "OnboardingWizardView-module__SaShFa__logoContainer",
  "mainCanvas": "OnboardingWizardView-module__SaShFa__mainCanvas",
  "mainCanvasStep2": "OnboardingWizardView-module__SaShFa__mainCanvasStep2",
  "mainCanvasStep3": "OnboardingWizardView-module__SaShFa__mainCanvasStep3",
  "mobileHeader": "OnboardingWizardView-module__SaShFa__mobileHeader",
  "mobileScrollSpacer": "OnboardingWizardView-module__SaShFa__mobileScrollSpacer",
  "mobileSheetFooter": "OnboardingWizardView-module__SaShFa__mobileSheetFooter",
  "pageWrapper": "OnboardingWizardView-module__SaShFa__pageWrapper",
  "pageWrapperStep2": "OnboardingWizardView-module__SaShFa__pageWrapperStep2",
  "pageWrapperStep3": "OnboardingWizardView-module__SaShFa__pageWrapperStep3",
  "rightCard": "OnboardingWizardView-module__SaShFa__rightCard",
  "socialContainer": "OnboardingWizardView-module__SaShFa__socialContainer",
  "step2ElieContainer": "OnboardingWizardView-module__SaShFa__step2ElieContainer",
  "step2ElieImg": "OnboardingWizardView-module__SaShFa__step2ElieImg",
  "step2FloatingSupportDesktop": "OnboardingWizardView-module__SaShFa__step2FloatingSupportDesktop",
  "step2LeftCard": "OnboardingWizardView-module__SaShFa__step2LeftCard",
  "step2LogoContainer": "OnboardingWizardView-module__SaShFa__step2LogoContainer",
  "step2RightColumn": "OnboardingWizardView-module__SaShFa__step2RightColumn",
  "step2SocialBtn": "OnboardingWizardView-module__SaShFa__step2SocialBtn",
  "step2SocialContainer": "OnboardingWizardView-module__SaShFa__step2SocialContainer",
  "step2WaBtn": "OnboardingWizardView-module__SaShFa__step2WaBtn",
  "step2WaGlowBtn": "OnboardingWizardView-module__SaShFa__step2WaGlowBtn",
  "step2WaPulseGlow": "OnboardingWizardView-module__SaShFa__step2WaPulseGlow",
  "step3ElieContainer": "OnboardingWizardView-module__SaShFa__step3ElieContainer",
  "step3ElieImg": "OnboardingWizardView-module__SaShFa__step3ElieImg",
  "step3LeftColumn": "OnboardingWizardView-module__SaShFa__step3LeftColumn",
  "step3SocialBtn": "OnboardingWizardView-module__SaShFa__step3SocialBtn",
  "step3SocialContainer": "OnboardingWizardView-module__SaShFa__step3SocialContainer",
  "step3WaGlowBtn": "OnboardingWizardView-module__SaShFa__step3WaGlowBtn",
  "topActionBtn": "OnboardingWizardView-module__SaShFa__topActionBtn",
  "waGlowBtn": "OnboardingWizardView-module__SaShFa__waGlowBtn",
  "waPulseGlow": "OnboardingWizardView-module__SaShFa__waPulseGlow",
  "waRadarPing": "OnboardingWizardView-module__SaShFa__waRadarPing",
  "waRadarRing": "OnboardingWizardView-module__SaShFa__waRadarRing",
  "waRadarRingDelayed": "OnboardingWizardView-module__SaShFa__waRadarRingDelayed",
});
